interface TagProps {
  children: React.ReactNode;
  tone?: "primary" | "secondary" | "accent" | "plain";
}

const toneClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-800 border-primary-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-200",
  plain: "bg-background-100 text-foreground-700 border-background-300"
};

export default function Tag({ children, tone = "secondary" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${toneClass[tone]}`}
    >
      {children}
    </span>
  );
}